/**
 * Utility functions for favicon manipulation
 */

// Theme to favicon path mapping
const THEME_ICONS = {
  Default: '/jobizo.ico',
  Diwali: '/icons/Diwali.ico',
  // Add more themes and their corresponding icon paths here
};

/**
 * Changes the favicon based on theme name
 * @param {string} theme - Theme name (e.g., 'diwali')
 */
export const changeFaviconByTheme = (theme) => {
  console.log("theme", theme);
  
  const iconPath = THEME_ICONS[theme] ;
  changeFavicon(iconPath);
};

/**
 * Changes the favicon to the specified URL
 * @param {string} href - The path to the new favicon
 */
export const changeFavicon = (href) => {
  // Find existing favicon link or create a new one
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;

  // Also update apple-touch-icon if it exists
  const appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']");
  if (appleTouchIcon) {
    appleTouchIcon.href = href;
  }
};

/**
 * Resets the favicon to the default one
 */
export const resetFavicon = () => {
  changeFavicon(THEME_ICONS.Default);
};
